// extracted by mini-css-extract-plugin
export var RootDiv = "event-page-module--RootDiv--9933f";
export var actuChip = "event-page-module--actuChip--4c3af";
export var author = "event-page-module--author--6c393";
export var blocCover = "event-page-module--blocCover--17b7d";
export var blocTitre = "event-page-module--blocTitre--3020c";
export var chip = "event-page-module--chip--442af";
export var chipHover = "event-page-module--chipHover--3a796";
export var contentBottomLayout = "event-page-module--contentBottomLayout--68f56";
export var contentHeader = "event-page-module--contentHeader--9e61f";
export var contentRelated = "event-page-module--contentRelated--83564";
export var contentTitle = "event-page-module--contentTitle--1d428";
export var divTitre = "event-page-module--divTitre--af6fa";
export var espacement = "event-page-module--espacement--09b30";
export var innerBloc = "event-page-module--innerBloc--d86ec";
export var innerBlocTitre = "event-page-module--innerBlocTitre--76521";
export var relatedContentDesktop = "event-page-module--relatedContentDesktop--65abe";
export var rootContent = "event-page-module--rootContent--868df";